import "./projects-page.css";

import FlipCardComponent from "../../components/flip-card/flip-card";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

import {
  EffectCoverflow,
  Pagination,
  Navigation,
  Autoplay,
} from "swiper/modules";

function ProjectsPage() {
  const projects = [
    {
      title: "Hostel Inquiry Management System",
      body: "System created for the University Of Ruhuna to Handle Student's hostel inquiries. Student can individually send their inquiries to the upper-management. Management can move the inquiry to upper levels if they couldn't give any solution. High level users can follow up the process and monitor student inquiries.",
      buttonLink: "http://192.248.48.189:3000/",
      imageLink:
        "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013146/hostel_eowfki.webp",
      chipList: ["MERN Stack", "Linux", "HTML", "CSS", "User Auth"],
    },
    {
      title: "Academic Data Record System ",
      body: "Internal System for the Lecturers at University of Ruhuna to manage their details through a system. Mange their daily work, Achievements, Awards etc, by using a user specific dashboard. This project initially created using Pure PHP and converted to MERN Stack. This is the very first project I did as a professional.",
      buttonLink: "https://github.com/mudith-perera/deans-office",
      imageLink:
        "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013144/dean-office_hglcgp.webp",
      chipList: ["MERN Stack", "Linux", "HTML", "CSS", "User Auth"],
    },
    {
      title: "Uninotes",
      body: "Uninotes is a Business E-commerce platform created for a local customer. This platform provide many functionalities such as, Universities can publish their courses, scholarship programmes for the users to see via the website and gather leads. Users also who are looking for a course can manage their own profile to save the favorite courses and many more. ",
      buttonLink: "https://uninotes.lk/",
      imageLink:
        "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013145/uninotes_n7hmo5.webp",
      chipList: ["MERN Stack", "Azure", "Google Auth", "Email"],
    },
    {
      title: "FitFinder",
      body: "This Web Project was created as the Final Year Project. This system facilitates Gym owners to market their Gym and register users as Members and Coaches to the system and manage them. Users can make payments to the Registered gym via Stripe payment gateway. Also Members can be assigned to the coaches and coaches can manage the member's workout schedule via the system.",
      buttonLink: "https://github.com/mudith-perera/FitFinder",
      imageLink:
        "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013145/fitfinder_neytfr.webp",
      chipList: [
        "MERN Stack",
        "Azure",
        "Google Auth",
        "Payment Gateway",
        "ChatBot",
      ],
    },
    {
      title: "BoardMe",
      body: "This Web Project was created for the HackX event held in University of Kelaniya. This system facilitates Boarding House owners to market their Boarding House and user are able to find the best matching boarding house for them using the system. Me and my Team were able to enter the final rounds with this Web Application.",
      buttonLink: "https://github.com/mudith-perera/BoardME",
      imageLink:
        "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013145/boardme_n9wjod.webp",
      chipList: ["React", "Laravel", "HTML", "CSS", "User Auth"],
    },
    {
      title: "Seat Booking System",
      body: "This is a desktop application developed using Java and JavaFX. This system can make bookings for a month for a given time period. Seats are swappable and can be manage by the admin.",
      buttonLink: "https://github.com/mudith-perera/Cinema_Seat_Booking_System",
      imageLink:
        "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013144/seat_ontlcb.webp",
      chipList: ["Java", "JavaFX", "OOP Concepts", "IntelliJ IDEA"],
    },
  ];
  return (
    <div className="projects-main" id="projects">
      <div className="projects-container">
        <div className="global-title" data-aos="fade-up">
          Projects
        </div>
        <div className="global-subtitle" data-aos="fade-up">
          Showcase of Top Projects I've Done
        </div>

        <Swiper
          data-aos="fade-up"
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          navigation={true}
          slidesPerView={"auto"}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 0,
            modifier: 1,
            slideShadows: false,
          }}
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 2600,
            disableOnInteraction: true,
          }}
          loop={true}
          modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
          className="mySwiper"
        >
          {projects.map((project) => (
            <SwiperSlide key={project.title}>
              <div className="grid-item-proj">
                <FlipCardComponent
                  title={project.title}
                  body={project.body}
                  buttonLink={project.buttonLink}
                  imageLink={project.imageLink}
                  chipList={project.chipList}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default ProjectsPage;
